import { Link } from 'react-router-dom';
import { mainSiteUrl } from '@/mocks/categories';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[720px] flex items-center justify-center overflow-hidden pt-14">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=A%20luxurious%20fashion%20boutique%20interior%20with%20curated%20designer%20garments%20on%20brass%20clothing%20racks%2C%20soft%20warm%20golden%20afternoon%20light%20streaming%20through%20large%20windows%2C%20neutral%20cream%20and%20terracotta%20color%20palette%2C%20premium%20shoes%20and%20handbags%20on%20display%20shelves%2C%20editorial%20commercial%20photography%20style%20with%20high%20end%20retail%20atmosphere%20and%20organic%20textures&width=1600&height=900&seq=hero-bg-main&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45" />

      <div className="relative z-10 w-full max-w-4xl mx-auto px-6 md:px-8 text-center">
        <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100/80 text-accent-800 text-sm font-medium mb-6 tracking-wide">
          Updated for 2026
        </span>

        <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-6 leading-tight">
          The Complete <span className="italic">BaseTao Spreadsheet</span> Guide
        </h1>

        <p className="text-lg md:text-xl text-white/85 max-w-2xl mx-auto mb-10 leading-relaxed">
          Discover honest BaseTao Spreadsheet reviews, shipping cost breakdowns, warehouse guides, discount resources, and expert tutorials — all in one place.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3.5 rounded-lg bg-primary-500 text-white font-semibold text-base hover:bg-primary-600 transition-colors duration-200 cursor-pointer"
          >
            BaseTao Spreadsheet
            <i className="ri-arrow-right-up-line w-5 h-5 flex items-center justify-center"></i>
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3.5 rounded-lg bg-white/15 backdrop-blur-sm text-white font-semibold text-base border border-white/25 hover:bg-white/25 transition-colors duration-200 cursor-pointer"
          >
            Buy It Now
            <i className="ri-shopping-bag-line w-5 h-5 flex items-center justify-center"></i>
          </a>
        </div>

        <div className="mt-12">
          <Link
            to="/article/basetao-spreadsheet-guide"
            className="whitespace-nowrap inline-flex items-center gap-2 text-white/70 hover:text-white text-sm transition-colors duration-200 cursor-pointer"
          >
            Read the Full BaseTao Spreadsheet Guide
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}